'use strict';

var AdminUser = require('components/profile/views/admin_user_view');
var ApiConfigView = require('components/profile/views/api_configuration_view');
var ApiDocView = require('components/profile/views/api_documentation_view');
var App = require('app');
var AppState = require('app_state');
var BreadcrumbView = require('components/profile/views/device_report_breadcrumbs_view');
var BillingView = require('components/profile/views/billing_view');
var CommonViews = require('components/common/views');
var Consts = require('consts');
var MailboxesDialogView = require('components/profile/views/mailbox_dialog_view');
var GatewayReportView = require('components/profile/views/gateway_report_view');
var DeviceReportView = require('components/profile/views/device_report_view');
var DeviceReportDialog = require('components/profile/views/device_report_dialog_view');
var DeviceReportContentDialog = require('components/profile/views/device_report_content_dialog_view');
var DeviceReportContentView = require('components/profile/views/device_report_content_list_view');
var DeviceReportDownloadDialog = require('components/profile/views/device_report_download_dialog_view');
var GroupsController = require('components/devices/controllers/groups');
var HomeController = require('components/home/home_controller');
var i18n = require('utils/i18n');
var LabelPoolView = require('components/profile/views/label_pool_view');
var LabelPoolDialogView = require('components/profile/views/label_pool_dialog_view');
var MailboxListView = require('components/profile/views/mailbox_list_view');
var Misc = require('utils/misc');
var Notification = require('utils/notification');
var ProfilePhoneDialog = require('components/profile/views/profile_phone_dialog');
var ProfileMFADialog = require('components/profile/views/profile_mfa_dialog');
var SettingsView = require('components/profile/views/settings_view');
var ReportDevices = require('models/reports_device');
var Utils = require('components/common/utils');
var WebhookView = require('components/profile/views/webhook_view');
var WebhookDialogView = require('components/profile/views/webhook_dialog_view');
var WebhookModel = require('models/company');

var ProfileController = {};

function getDefaultFilter() {
    var urlFilter = AppState.getURLParameter(['sortCol', 'sortDesc', 'offset', 'limit', 'filter']);
    return {
        sortCol: urlFilter.sortCol || 'name',
        sortDesc: urlFilter.sortDesc || false,
        offset: urlFilter.offset || 0,
        limit: urlFilter.limit || AppState.getItemsPerPage() || 10,
        filter: urlFilter.filter || '',
    };
}

ProfileController.profilePageInit = function (active_tab, cb) {
    var self = this;
    HomeController.showBaseLayout({
        cb: function (permissions, style) {
            AppState.layout.breadcrumbs.reset();

            var features = App.request('company:features');
            $.when(features).done(function (featureFlags) {
                App.trigger('sidebar:profile', active_tab, featureFlags);
                cb(self);
            });
        },
    });
};

ProfileController.showWebhookDialog = function (webhookModel, callBackFunc) {
    $.when(App.request('alarm:list', undefined, true)).done(function (alarmList) {
        webhookModel = webhookModel || new WebhookModel.Webhook();

        App.showModal(
            new WebhookDialogView({ alarmList: alarmList, webhookModel: webhookModel, callBackFunc: callBackFunc })
        );
    });
};

ProfileController.WebhookView = function () {
    var self = this;
    this.profilePageInit('webhooks', function (controller) {
        var req = App.request('webhook:list');
        $.when(req).done(function (webhookList) {
            var contentView;
            if (webhookList === undefined) {
                contentView = new CommonViews.Message({
                    title: i18n.TR('Fehler'),
                    text: i18n.TR('Webhook Liste konnte nicht geladen werden.'),
                    color_class: 'box-color-error',
                });
            } else {
                if (webhookList.length > 0) {
                    contentView = new WebhookView({
                        controller: controller,
                        collection: webhookList,
                    });
                } else {
                    contentView = new CommonViews.Message({
                        title: i18n.TR('Keine Webhooks vorhanden'),
                        text: i18n.TR('Momentan sind keine Webhooks konfiguriert.'),
                        action_label: i18n.TR('Webhook hinzufügen'),
                        action_cb: function () {
                            self.showWebhookDialog(undefined, function () {
                                // reload page
                                Backbone.history.loadUrl(Backbone.history.fragment);
                            });
                        },
                    });
                }
            }
            App.showContentView(contentView);
        });
    });
};

ProfileController.MailboxListView = function () {
    var req = App.request('company:mailboxes');
    var self = this;
    $.when(req).done(function (mailboxes) {
        if (mailboxes) {
            var contentView = new MailboxListView({
                controller: self,
                collection: mailboxes,
            });
        }

        self.profilePageInit('access-mailboxes', function (controller) {
            if (mailboxes.length > 0) {
                App.showContentView(contentView);
            } else {
                var emptyView = new CommonViews.Message({
                    title: i18n.TR('Keine Postfächer vorhanden'),
                    text: i18n.TR('Momentan sind keine Postfächer konfiguriert.'),
                    action_label: i18n.TR('Postfach hinzufügen'),
                    action_cb: function () {
                        self.showMailboxDialog({
                            title: i18n.TR('Neuer Eintrag'),
                            collection: mailboxes,
                            view: contentView,
                        });
                    },
                });
                App.showContentView(emptyView);
            }
        });
    });
};

ProfileController.showMailboxDialog = function (data) {
    var collection = data.collection;
    var isUpdate = data.model != undefined;
    var model = data.model;

    var view = new MailboxesDialogView({
        controller: this,
        name: data.name,
        email: data.email,
        title: data.title,
        collection: data.collection,
        model: data.model,
        url: collection.url,
        save_cb: function (params) {
            var options = {
                wait: true,
                success: function (model) {
                    Notification.show(
                        'success',
                        i18n.TR('Erfolg'),
                        i18n.TR('Das Postfach wurde erfolgreich gespeichert.')
                    );
                    App.hideModal();
                    Backbone.history.loadUrl(Backbone.history.fragment);
                },
                error: function (response) {
                    Notification.show(
                        'error',
                        i18n.TR('Fehler'),
                        i18n.TR('Speichern der E-Mail-Adresse fehlgeschlagen.')
                    );
                },
            };
            if (isUpdate) {
                options.url = model.url();
                collection.sync('update', model, options);
            } else {
                collection.create(params, options);
            }
        },
    });
    App.showModal(view);
};

ProfileController.BillingView = function () {
    this.profilePageInit('billing', function (controller) {
        // fetch billing information
        var billingInfo = App.request('company:billing');
        $.when(billingInfo).done(function (billingInfo) {
            var contentView;
            if (billingInfo === undefined) {
                contentView = new CommonViews.Message({
                    title: i18n.TR('Fehler'),
                    text: i18n.TR('Rechnungen konnten nicht geladen werden.'),
                    color_class: 'box-color-error',
                });
            } else {
                contentView = new BillingView({
                    controller: controller,
                    model: billingInfo,
                });
            }
            App.showContentView(contentView);
        });
    });
};

ProfileController.AdminUser = function () {
    this.profilePageInit('access-admins', function (controller) {
        // fetch user information
        var users = App.request('company:users', 'admin');
        $.when(users).done(function (users) {
            var contentView;
            if (users === undefined) {
                contentView = new CommonViews.Message({
                    title: i18n.TR('Fehler'),
                    text: i18n.TR('Administratoren konnten nicht geladen werden.'),
                    color_class: 'box-color-error',
                });
            } else {
                contentView = new AdminUser({
                    controller: controller,
                    collection: users,
                });
            }
            App.showContentView(contentView);
        });
    });
};

ProfileController.DeviceGroups = function (showUserGroups) {
    this.profilePageInit(showUserGroups ? 'access-user-groups' : 'access-device-groups', function (controller) {
        var groups = new GroupsController();
        groups.displayGroupList(showUserGroups);
    });
};

ProfileController.ApiDocumentationView = function (api_key) {
    this.profilePageInit('api', function (controller) {
        App.showContentView(new ApiDocView({ api_key: api_key }));
    });
};

ProfileController.ApiConfigurationView = function (api_key) {
    this.profilePageInit('access-api-config', function (controller) {
        var tokens = App.request('company:api-tokens');
        var groups = App.request('groups:list', Consts.GroupReqMode.User);

        $.when(tokens, groups).done(function (tokens, groups) {
            var contentView;
            if (tokens === undefined || groups === undefined) {
                contentView = new CommonViews.Message({
                    title: i18n.TR('Fehler'),
                    text: i18n.TR('API Token konnten nicht geladen werden.'),
                    color_class: 'box-color-error',
                });
            } else {
                contentView = new ApiConfigView({
                    controller: controller,
                    collection: tokens,
                    groups: groups,
                });
            }
            App.showContentView(contentView);
        });
    });
};

ProfileController.setReportDevicesActive = function (reports, setActive, callback, callbackErr) {
    var req = App.request('report:devices:update', Misc.getSelectionIDs(reports), { is_active: setActive });
    $.when(req).done(function (result) {
        if (result && callback) callback();
        if (!result && callbackErr) callbackErr();
    });
};

ProfileController.reportDevicesDownload = function (id, title) {
    var self = this;
    $.when(
        App.request('report:devices:files', {
            reportID: id,
            limit: AppState.getItemsPerPage(),
            sortDesc: true,
            sortCol: 'till',
        })
    ).done(function (files) {
        if (!files) {
            Notification.show('error', i18n.TR('Fehler'), i18n.TR('Das Laden der Berichtliste ist fehlgeschlagen.'));
            return;
        }

        App.showModal(
            new DeviceReportDownloadDialog({
                controller: self,
                listResult: files,
                title: title,
                reportID: id,
                currentSortDesc: true,
                currentSortCol: 'till',
                cb: function (model) {
                    App.hideModal();
                },
            })
        );
    });
};

ProfileController.reportDevicesEdit = function (id, fromContent) {
    $.when(App.request('report:devices:model', id), App.request('company:mailboxes')).done(function (model, mailboxes) {
        if (!model) {
            Notification.show('error', i18n.TR('Fehler'), i18n.TR('Das Laden des Berichts ist fehlgeschlagen.'));
            return;
        }

        App.showModal(
            new DeviceReportDialog({
                model: model,
                mailboxes: mailboxes,
                cb: function (model) {
                    model.save(
                        {},
                        {
                            success: function (m) {
                                App.hideModal();
                                App.trigger('profile:reports:device', fromContent ? id : undefined);
                            },
                            error: function () {
                                Notification.show(
                                    'error',
                                    i18n.TR('Fehler'),
                                    i18n.TR('Das Speichern des Berichts ist fehlgeschlagen.')
                                );
                            },
                        }
                    );
                },
            })
        );
    });
};

ProfileController.reportDevicesContentFct = function (reportID, modelID, fct) {
    // model is nr
    $.when(App.request('report:devices:content', reportID)).done(function (list) {
        var model = list ? list.get(modelID) : undefined;
        if (model) {
            model.reportID = reportID;
        }
        fct(reportID, model);
    });
};

ProfileController.reportDevicesContentEdit = function (reportID, model) {
    $.when(App.request('report:devices:model', reportID)).done(function (reportModel) {
        App.showModal(
            new DeviceReportContentDialog({
                reportFormat: reportModel.get('format'),
                reportID: reportID,
                model: model,
                cb: function (content) {
                    content.reportID = reportID;
                    content.save(
                        {},
                        {
                            success: function () {
                                App.hideModal();
                                App.trigger('profile:reports:device', reportID);
                            },
                            error: function () {
                                Notification.show(
                                    'error',
                                    i18n.TR('Fehler'),
                                    i18n.TR('Das Speichern des Berichts ist fehlgeschlagen.')
                                );
                            },
                        }
                    );
                },
            })
        );
    });
};

ProfileController.reportDevicesContentMove = function (model, dir) {
    $.when(App.request('profile:reports:device:content:move', model, dir)).done(function (ok) {
        if (!ok) {
            Notification.show('error', i18n.TR('Fehler'), i18n.TR('Die Änderung des Berichts ist fehlgeschlagen.'));
            return;
        }
        App.trigger('profile:reports:device', model.reportID);
    });
};

ProfileController.reportDevicesContentAdd = function (id) {
    $.when(App.request('report:devices:model', id)).done(function (reportModel) {
        App.showModal(
            new DeviceReportContentDialog({
                reportID: id,
                reportFormat: reportModel.get('format'),
                model: new ReportDevices.ReportContent.Model({
                    reportID: id,
                }),
                cb: function (content) {
                    content.reportID = id;
                    content.save(
                        {},
                        {
                            success: function () {
                                App.hideModal();
                                App.trigger('profile:reports:device', id);
                            },
                            error: function () {
                                Notification.show(
                                    'error',
                                    i18n.TR('Fehler'),
                                    i18n.TR('Das Speichern des Berichts ist fehlgeschlagen.')
                                );
                            },
                        }
                    );
                },
            })
        );
    });
};

ProfileController.reportDevicesAdd = function () {
    $.when(App.request('company:mailboxes')).done(function (mailboxes) {
        App.showModal(
            new DeviceReportDialog({
                model: new ReportDevices.Model({
                    is_active: true,
                }),
                mailboxes: mailboxes,
                cb: function (model) {
                    model.save(
                        {},
                        {
                            success: function (m) {
                                App.hideModal();
                                App.trigger('profile:reports:device', model.id, true);
                            },
                            error: function () {
                                Notification.show(
                                    'error',
                                    i18n.TR('Fehler'),
                                    i18n.TR('Das Speichern des Berichts ist fehlgeschlagen.')
                                );
                            },
                        }
                    );
                },
            })
        );
    });
};

ProfileController.DeviceReportListView = function (controller) {
    var self = this;
    var filter = getDefaultFilter();
    $.when(App.request('report:devices:list', filter)).done(function (list) {
        if (list === undefined) {
            App.showContentView(
                new CommonViews.Message({
                    title: i18n.TR('Fehler'),
                    text: i18n.TR('Geräteberichte konnten nicht geladen werden.'),
                    color_class: 'box-color-error',
                })
            );
            return;
        }

        if (list.count == 0) {
            var emptyView = new CommonViews.Message({
                title: i18n.TR('Keine Geräteberichte vorhanden'),
                text: i18n.TR('Momentan sind keine Geräteberichte konfiguriert.'),
                action_label: i18n.TR('Gerätebericht hinzufügen'),
                action_cb: function () {
                    self.reportDevicesAdd();
                },
            });
            App.showContentView(emptyView);
            return;
        }

        App.showContentView(
            new DeviceReportView({
                controller: self,
                listResult: list,
                config: filter,
                itemsPerPage: AppState.getItemsPerPage() || 10,
            })
        );
    });
};

ProfileController.DeviceReportContentListView = function (controller, id) {
    var self = this;

    $.when(App.request('report:devices:content', id), App.request('report:devices:model', id)).done(function (list, m) {
        if (list === undefined) {
            App.showContentView(
                new CommonViews.Message({
                    title: i18n.TR('Fehler'),
                    text: i18n.TR('Gerätebericht konnten nicht geladen werden.'),
                    color_class: 'box-color-error',
                })
            );
            return;
        }

        var formatIcon = { icon: '', name: '?' };
        if (m) {
            switch (m.get('format')) {
                case 1:
                    formatIcon = { icon: 'fa-file-excel-o', name: i18n.TR('CSV') };
                    break;
                case 2:
                    formatIcon = { icon: 'fa-file-pdf-o', name: i18n.TR('PDF') };
                    break;
            }
        }

        AppState.layout.showChildView(
            'breadcrumbs',
            new BreadcrumbView({
                controller: self,
                id: id,
                name: m.get('name'),
                format: formatIcon,
            })
        );

        if (list.length == 0) {
            App.showContentView(
                new CommonViews.Message({
                    title: i18n.TR('Der Gerätebericht ist leer'),
                    text: i18n.TR('Momentan ist kein Inhalt für den Bericht konfiguriert.'),
                    action_label: i18n.TR('Abschnitt hinzufügen'),
                    action_cb: function () {
                        self.reportDevicesContentAdd(id);
                    },
                })
            );
            return;
        }

        // attempt to get the preview
        $.when(App.request('report:devices:preview:prepare', id)).done(function (handle) {
            // refresh the preview region
            App.showContentView(
                new DeviceReportContentView({
                    controller: self,
                    collection: list,
                    reportID: id,
                    reportName: m.get('name'),
                    format: m.get('format'),
                    handle: handle,
                })
            );
        });
    });
};

ProfileController.DeviceReportView = function (id) {
    this.profilePageInit('report-devices', function (controller) {
        if (!id) {
            ProfileController.DeviceReportListView(controller);
        } else {
            ProfileController.DeviceReportContentListView(controller, id);
        }
    });
};

ProfileController.GatewayReportView = function () {
    var self = this;
    this.profilePageInit('report-communication', function (controller) {
        // todo: account for bookmarks
        var filter = getDefaultFilter();
        var statistics = App.request('gateway:connection:statistics', filter);
        $.when(statistics).done(function (statistics) {
            var contentView;
            if (statistics === undefined) {
                contentView = new CommonViews.Message({
                    title: i18n.TR('Fehler'),
                    text: i18n.TR('Gatewayverbindungsdaten konnten nicht geladen werden.'),
                    color_class: 'box-color-error',
                });
            } else {
                var limit = AppState.getItemsPerPage();
                contentView = new GatewayReportView({
                    controller: self,
                    listResult: statistics.collection,
                    collection: statistics.collection,
                    count: statistics.count,
                    average_values: statistics.average_values,
                    config: filter,
                    itemsPerPage: limit || 10,
                    colConfig: statistics.columns,
                });
            }

            App.showContentView(contentView);
        });
    });
};

ProfileController.saveApiToken = function (token, error_cb) {
    token.set(
        'groups',
        _.map(token.get('groups'), function (g) {
            return parseInt(g);
        })
    );
    token.save(
        {},
        {
            success: function () {
                Notification.show('success', i18n.TR('Erfolg'), i18n.TR('API Token wurde gespeichert.'));
                App.hideModal();
                App.trigger('profile:api-config');
            },
            error: function (model, r) {
                error_cb(r.responseJSON || { error: r.responseText });
            },
        }
    );
};

ProfileController.Settings = function (isLangChange) {
    this.profilePageInit('settings', function (controller) {
        var deviceSummary = App.request('device:summary', 'profile');
        $.when(deviceSummary).done(function (deviceSummary) {
            App.showContentView(
                new SettingsView.ProfileView({
                    controller: controller,
                    deviceSummary: deviceSummary,
                    isLangChange: isLangChange,
                })
            );
        });
    });
};

ProfileController.SettingsDialog = function (entryParams, fields) {
    var view = new SettingsView.DialogView({
        controller: this,
        parameter: entryParams,
        inputFields: fields,
    });
    App.showModal(view);
};

ProfileController.showMessageDialog = function () {
    var view = new SettingsView.MessageView({
        controller: this,
    });
    App.showModal(view);
};

ProfileController.showVersionDialog = function () {
    var view = new SettingsView.FrontendVersionView({
        controller: this,
    });
    App.showModal(view);
};

ProfileController.showPhoneDialog = function () {
    var dlg = new ProfilePhoneDialog({
        onSuccess: function () {
            Notification.show('success', i18n.TR('Erfolg'), i18n.TR('Ihre Telefonnummer wurde gespeichert.'));
            App.hideModal();
            App.trigger('profile:show:settings');
        },
    });
    App.showModal(dlg);
};

ProfileController.showPhoneDeleteConfirmation = function () {
    var onSuccess = function () {
        Notification.show('success', i18n.TR('Erfolg'), i18n.TR('Eintrag wurde gelöscht.'));
        App.hideModal();
        App.trigger('profile:show:settings');
    };
    var onFail = function () {
        Notification.show('error', i18n.TR('Fehler'), i18n.TR('Eintrag konnte nicht gelöscht werden.'));
    };

    Utils.showConfirmationDialog({
        title: i18n.TR('Eintrag löschen'),
        hint: i18n.TR('Wollen Sie die gespeicherte Handynummer wirklich löschen?'),
        action_label: i18n.TR('Löschen'),

        action_cb: function () {
            var req = App.request('user:phone:delete');
            $.when(req).then(onSuccess, onFail);
        },
    });
};

ProfileController.showMFAconfigurationDialog = function (mfaActivationOnLogin) {
    var dlg = new ProfileMFADialog({
        mfaActivation: mfaActivationOnLogin,
        onSuccess: function () {
            Notification.show('success', i18n.TR('Erfolg'), i18n.TR('Ihre 2FA-Einstellungen wurden gespeichert.'));
            App.hideModal();
            if (mfaActivationOnLogin) {
                // show usual start screen
                var AccountController = require('components/account/account_controller');
                AccountController.startSession();
                return;
            }
            // hard page reload - already fetched MFA information might be invalidated
            location.reload(true);
        },
    });
    App.showModal(dlg);
};

ProfileController.updateUserData = function (params) {
    App.ajax({
        url: '/api/v1/me',
        type: 'POST',
        data: {
            username: params.form.username || '',
            newPassword: params.form.newPassword || '',
            curPassword: params.form.curPassword || '',
            email: params.form.email || '',
            language: params.form.language || '',
            isExpert: params.form.isExpert || '',
            updateType: params.form.updateType || 'TypeUndefined',
        },
        success: function () {
            params.success();
        },
        error: function (xhr) {
            var errors = xhr.responseJSON || { error: xhr.responseText };
            params.error(errors);
        },
    });
};

ProfileController.updateStyle = function (params) {
    params.model.save(
        {},
        {
            success: function () {
                params.success_cb();
            },
            error: function () {
                params.error_cb();
            },
        }
    );
};

ProfileController.showDialog = function (event) {
    var dialogType = $(event.currentTarget).attr('id').substring(3);

    switch (dialogType) {
        case 'phone':
            ProfileController.showPhoneDialog();
            break;
        case 'deletePhoneNumber':
            ProfileController.showPhoneDeleteConfirmation();
            break;
        case 'mfaConfiguration':
            ProfileController.showMFAconfigurationDialog();
            break;
        case 'messages':
            ProfileController.showMessageDialog();
            break;
        case 'version':
            ProfileController.showVersionDialog();
            break;
        default:
            this.SettingsDialog(this.dialogSettings[dialogType].settings, this.dialogSettings[dialogType].validation);
            break;
    }
};

ProfileController.dialogSettings = {
    password: {
        settings: {
            label: i18n.TR('Neues Passwort'),
            cur_pass_req: true,
            type: 'password',
            success_message: i18n.TR('Ihr neues Passwort wurde gesetzt.'),
            el_id: 'newPassword',
            updateType: 'TypePasswordUpdate',
        },
        validation: {
            newPassword: {
                method: 'password',
                decoIcon: 'glyphicon glyphicon-ok',
                min: 8,
            },
            curPassword: {},
        },
    },
    email: {
        settings: {
            label: i18n.TR('E-Mail'),
            cur_pass_req: true,
            type: 'email',
            success_message: i18n.TR('Es wurde eine Verifikationsmail an Ihre neue E-Mail Adresse gesendet.'),
            el_id: 'email',
            updateType: 'TypeEmailUpdate',
            content: function () {
                return AppState.user.attributes.email;
            },
            hint:
                i18n.TR('Beim ändern der E-Mail-Adresse wird an die neue Adresse eine Validierungsmail verschickt. ') +
                i18n.TR('Ohne Validierung gilt die alte E-Mail-Adresse als Login-Adresse.'),
        },
        validation: {
            email: {
                method: 'email',
                min: 5,
                regexp: RegExp('.*@.*', 'i'),
            },
            curPassword: {},
        },
    },
    username: {
        settings: {
            label: i18n.TR('Benutzername'),
            type: 'text',
            success_message: i18n.TR('Ihr Benutzername wurde aktualisiert.'),
            el_id: 'username',
            content: function () {
                return AppState.user.attributes.name;
            },
            updateType: 'TypeUsernameUpdate',
        },
        validation: {
            username: {},
        },
    },
    language: {
        settings: {
            label: i18n.TR('Sprache'),
            el_id: 'language',
            // i18n.TR('Die Aktualisierung der Sprache war erfolgreich.'),
            // -> previous line: ensure that "tc translation" finds the string
            //    next line:     translate _after_ the language was switched
            success_message: i18n.TR('Die Aktualisierung der Sprache war erfolgreich.'),
            hint: i18n.TR('Bezieht sich auf die Sprache des UI und der Sprache für System-E-Mails.'),
            updateType: 'TypeLanguageUpdate',
            selectedValue: function () {
                return AppState.user.get('lang');
            },
            dropdownItems: function () {
                return i18n.languagesList();
            },
        },
        validation: {
            language: {},
        },
    },
    isExpert: {
        settings: {
            label: i18n.TR('Darstellung'),
            el_id: 'isExpert',
            success_message: i18n.TR('Darstellungsauswahl aktualisiert.'),
            updateType: 'TypeIsExpertUpdate',
            selectedValue: function () {
                return AppState.user.attributes.is_expert;
            },
            dropdownItems: [
                {
                    key: 'false',
                    value: i18n.TR('Standard'),
                },
                {
                    key: 'true',
                    value: i18n.TR('Erweitert (Expertenmodus)'),
                },
            ],
        },
        validation: {
            isExpert: {},
        },
    },
};

ProfileController.setItemsPerPage = function (itemsPerPage) {
    AppState.saveItemsPerPage(itemsPerPage);
};

ProfileController.showLabelPoolDialog = function () {
    // read label pool and current labels
    $.when(App.request('label:pool:list'), App.request('filter:labels')).done(function (pool, labels) {
        App.showModal(
            new LabelPoolDialogView({
                model: new Backbone.Model({
                    pool: pool,
                    labels: labels.tags || [],
                }),
                cb: function () {
                    ProfileController.LabelPool();
                },
            })
        );
    });
};

ProfileController.LabelPool = function () {
    var self = this;
    this.profilePageInit('label-pool', function () {
        // read current label pool
        $.when(App.request('label:pool:list')).done(function (pool) {
            if (!pool) {
                App.showContentView(
                    new CommonViews.Message({
                        title: i18n.TR('Fehler'),
                        text: i18n.TR('Label Vorgaben konnten nicht geladen werden.'),
                        color_class: 'box-color-error',
                    })
                );
                return;
            }

            if (pool.length == 0) {
                var emptyView = new CommonViews.Message({
                    title: i18n.TR('Keine Label Vorgaben definiert'),
                    text: i18n.TR('Momentan sind keine Label Vorgaben definiert.'),
                    action_label: i18n.TR('Label Vorgaben konfigurieren'),
                    action_cb: function () {
                        ProfileController.showLabelPoolDialog();
                    },
                });
                App.showContentView(emptyView);
                return;
            }

            var contentView = new LabelPoolView({
                pool: pool,
                controller: self,
            });
            App.showContentView(contentView);
        });
    });
};

module.exports = ProfileController;
